// Mock data for EnovaAI Technologies landing page

export const siteConfig = {
  logoUrl: "https://customer-assets.emergentagent.com/job_enovalanding/artifacts/xoznlcv2_WhatsApp%20Image%202026-02-18%20at%2013.57.55.jpeg",
  companyName: "EnovaAI Technologies"
};

export const heroData = {
  title: "Innovating the Future with AI Excellence",
  subtitle: "EnovaAI Technologies delivers cutting-edge Artificial Intelligence solutions, empowering businesses and transforming operations globally.",
  primaryCTA: "Get Started Today",
  secondaryCTA: "Explore Our Solutions",
  stats: [
    { label: "Expert AI Solutions", value: "10+" },
    { label: "24/7 Support", value: "Always" },
    { label: "Global Reach", value: "Worldwide" }
  ]
};

export const solutions = [
  {
    id: 1,
    title: "Intelligent Automation",
    description: "Streamline operations and boost efficiency with AI-driven automation. From repetitive tasks to complex decision-making, our solutions learn and adapt.",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Predictive Analytics",
    description: "Leverage data to foresee trends, identify opportunities, and mitigate risks. Our AI models provide actionable insights for strategic growth.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Natural Language Processing",
    description: "Unlock the power of human language. Our NLP solutions enable intelligent chatbots, sentiment analysis, and content generation.",
    icon: "MessageSquare"
  },
  {
    id: 4,
    title: "Scalable Cloud Infrastructure",
    description: "Build robust and scalable backend systems on leading cloud platforms. Ensure your applications perform flawlessly under any load.",
    icon: "Cloud"
  },
  {
    id: 5,
    title: "API Development & Integration",
    description: "Seamlessly connect your services and data with secure, efficient API development and integration services.",
    icon: "Link"
  },
  {
    id: 6,
    title: "Database Management",
    description: "Expert design, implementation, and optimization of databases to ensure data integrity, security, and high performance.",
    icon: "Database"
  },
  {
    id: 7,
    title: "Agentic AI Systems",
    description: "Deploy autonomous AI agents that reason, plan, and execute complex multi-step workflows across your enterprise systems.",
    icon: "Bot"
  },
  {
    id: 8,
    title: "Computer Vision",
    description: "Transform visual data into actionable insights with advanced image recognition, object detection, and facial analysis capabilities.",
    icon: "Eye"
  }
];

export const caseStudies = [
  {
    id: 1,
    category: "Healthcare",
    title: "Medical AI Assistant",
    description: "24/7 multilingual patient management system",
    details: "Successfully delivered an AI-powered medical assistant that handles appointment booking, patient queries, and medical record management in 5 languages. The system integrates seamlessly with hospital systems and operates autonomously 24/7.",
    features: [
      "5 languages supported (EN, ES, HI, FR, AR)",
      "Real-time EHR integration",
      "Agentic AI decision-making",
      "HIPAA-compliant architecture"
    ],
    results: [
      "$2,500/year cost savings",
      "24/7 availability achieved",
      "120 hours/year saved"
    ],
    technologies: ["LangChain", "React", "TypeScript", "FastAPI", "GCP", "MongoDB"],
    image: "https://images.unsplash.com/photo-1694903110330-cc64b7e1d21d"
  },
  {
    id: 2,
    category: "Finance",
    title: "Financial Analytics Platform",
    description: "Real-time market analysis with AI-powered predictions",
    details: "Built an advanced financial analytics platform featuring proprietary ML models for market prediction. The platform processes real-time market data, detects anomalies, and provides intelligent investment recommendations.",
    features: [
      "Real-time market data processing",
      "Custom-trained prediction models",
      "Risk assessment algorithms",
      "Automated trading signals"
    ],
    results: [
      "85% prediction accuracy",
      "40% faster decision making",
      "Enhanced portfolio performance"
    ],
    technologies: ["Python", "TensorFlow", "React", "Node.js", "AWS", "PostgreSQL"],
    image: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86"
  }
];

export const aboutData = {
  title: "About EnovaAI Technologies",
  description: "At EnovaAI Technologies, our core philosophy revolves around harnessing the transformative power of Artificial Intelligence to create tangible, positive impacts on businesses and human life. We believe technology should serve humanity, making processes more efficient, decisions more informed, and experiences more intuitive.",
  mission: "Our team is dedicated to pushing the boundaries of innovation, delivering solutions that are not just technically superior but also ethically sound and user-centric. We are committed to building a future where technology seamlessly integrates into our lives, empowering us to achieve more.",
  website: "www.enovaaitechnologies.co.uk",
  founder: {
    name: "Mr. Ankit R Joshi",
    title: "Founder & CEO",
    bio: "Mr. Ankit R Joshi is a visionary entrepreneur and technology leader with extensive experience in Artificial Intelligence and enterprise solutions. As the Founder and CEO of EnovaAI Technologies, he leads the company's strategic vision to democratize AI capabilities and drive digital transformation for businesses globally. With a deep understanding of emerging technologies and a passion for innovation, Mr. Joshi has successfully architected and delivered cutting-edge AI solutions across diverse industries including healthcare, finance, and enterprise operations. His leadership philosophy centers on building ethical, user-centric technology that creates meaningful business value while maintaining the highest standards of innovation and excellence. Under his guidance, EnovaAI Technologies has established itself as a trusted partner for organizations seeking to harness the transformative power of Artificial Intelligence to achieve operational excellence and competitive advantage.",
    image: "https://customer-assets.emergentagent.com/job_enovalanding/artifacts/9ysajm0g_WhatsApp%20Image%202026-02-18%20at%2014.33.41.jpeg",
    linkedin: "https://www.linkedin.com/"
  }
};

export const contactData = {
  email: "Info@enovaaitechnologies.co.uk",
  phones: [
    "+7342286935",
    "+7391696804"
  ],
  responseTime: "We typically respond within 24 hours",
  availability: "Monday - Friday: 9 AM - 6 PM GMT",
  note: "Global timezone support available"
};
